import _ from 'lodash'

// WhatsApp's inline formatting markers, in the order they must be applied. Each entry
// captures the inner text so we can either wrap it in HTML (thread bubbles) or drop the
// markers entirely (compact list/teaser previews). Keeping the single source here avoids
// the marker regexes drifting between the two call sites.
const MARKERS = [
    { pattern: /```([^`]+)```/g, tag: 'code' },
    { pattern: /\*([^*\n]+)\*/g, tag: 'strong' },
    { pattern: /_([^_\n]+)_/g, tag: 'em' },
    { pattern: /~([^~\n]+)~/g, tag: 's' }
]

// Render WhatsApp markdown as safe HTML (escapes first, then applies the markers and
// turns newlines into <br>). Used for the thread bubbles (v-html).
export const toHtml = text => {
    let html = _.escape(text || '')
    MARKERS.forEach(({ pattern, tag }) => {
        html = html.replace(pattern, `<${tag}>$1</${tag}>`)
    })
    return html.replace(/\n/g, '<br>')
}

// Strip WhatsApp markers to clean plain text (keeps the words, drops the * _ ~ ` around
// them). Used for the one-line list preview where formatting can't render.
export const toPlain = text => {
    let plain = text || ''
    MARKERS.forEach(({ pattern }) => {
        plain = plain.replace(pattern, '$1')
    })
    return plain
}

export default { toHtml, toPlain }
